export default __webpack_public_path__ + "static/media/03.c1179671.jpg";